export default __webpack_public_path__ + "media/images/dividers/white-tear-e5dd7dd3139c9a026ee4fc281a163b39.svg";